import React from "react";
import { Chip, Stack } from "@mui/material";

export const parseTagsCsv = (str) => {
  if (!str || typeof str !== "string") return [];
  return str.split(",").map((t) => t.trim()).filter(Boolean);
};

const chipSx = {
  fontSize: "0.7rem",
  height: 20,
  maxWidth: "100%",
  "& .MuiChip-label": {
    px: 0.75,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
};

const CardTagsRow = ({ clientTags, requestTags, sx }) => {
  const cTags = parseTagsCsv(clientTags);
  const rTags = parseTagsCsv(requestTags);
  if (!cTags.length && !rTags.length) return null;

  return (
    <Stack
      direction="row"
      flexWrap="wrap"
      sx={{ columnGap: 0.75, rowGap: 0.25, minWidth: 0, maxWidth: "100%", ...sx }}
    >
      {cTags.map((tag, i) => (
        <Chip
          key={`c-${i}`}
          label={tag}
          size="small"
          variant="outlined"
          sx={chipSx}
        />
      ))}
      {rTags.map((tag, i) => (
        <Chip
          key={`r-${i}`}
          label={tag}
          size="small"
          color="primary"
          sx={chipSx}
        />
      ))}
    </Stack>
  );
};

export default CardTagsRow;
